module.exports = __webpack_public_path__ + "assets/01.2449b1c0.pdf";